<template>
  <div class="main-body">
    <div class="header">老人药品</div>
    <div class="out">
      <div class="search2">

          <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <div style="float:right">
            <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
            <el-date-picker
                v-model="startTime"
                type="date"
                style="margin-right:10px;"
                value-format="yyyy-MM-dd"
                placeholder="开始日期" class="search">
            </el-date-picker>
            <el-date-picker
                v-model="endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期" class="search">
            </el-date-picker>
            <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>

        <div style="clear: both;"></div>

      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column label="姓名" prop="elderlyName" width="200"></el-table-column>
        <el-table-column label="备注" prop="remarks" ></el-table-column>
        <el-table-column prop="createTime" :formatter="formatterTime" label="创建时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="timeSpan(scope.row.createTime)<4" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:zoneValue="zoneValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr,timefilters,getBeforeDate} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add";
import Edit from "./Edit";

export default {
  name: "Role",
  data(){
    return{
      loading:false,
      showModalAdd:false,
      showModalEdit:false,


      menuButtonList:null,
      disabledAdd:false,
      batchDialog:false,
      tableData:null,
      startTime:getBeforeDate(-30),
      endTime:getBeforeDate(0),
      elderlyName:'',
      rechargeType:0,
      batchFileList:[],
      zoneValue:[],
      datetimerangeValue:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      name:'',
    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    timeSpan(time){
      var d1 = new Date('2016/03/28 10:17:22');

      d1 = new Date(timefilters(time));
      var d2 = new Date();

      console.log(parseInt(d2 - d1));//两个时间相差的毫秒数
      console.log(parseInt(d2 - d1) / 1000);//两个时间相差的秒数
      console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的分钟数
      console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的小时数

      return parseInt(d2 - d1) / 1000 / 60/60;

    },

    handleEdit(index,row){
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myEdit.init(row);
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    formatterTime(row, column, cellValue) {
      return timefilters(cellValue)
    },

    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyDrugRecord/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyName:this.elderlyName,
          startTime:this.startTime,
          endTime:this.endTime,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    submitUpload(){
      this.$refs.upload.submit();
    },
    closeBatchDialog(){
      this.$refs.upload.clearFiles();
    },
    handleRemove(){

    },
  }
}
</script>

<style scoped>

</style>
